import {makeAutoObservable, runInAction} from 'mobx';

const OFFLINE_NOTICE_DELAY_MS = 8000;

class ServerAvailabilityStore {
    isServerUnavailable = false;
    shouldShowOfflineNotice = false;
    lastUnavailableAt?: number;
    lastErrorMessage?: string;
    private offlineNoticeTimer?: ReturnType<typeof setTimeout>;

    constructor() {
        makeAutoObservable(this);
    }

    reportFailure(error: unknown) {
        this.isServerUnavailable = true;
        this.lastUnavailableAt = Date.now();
        this.lastErrorMessage = error instanceof Error ? error.message : String(error);

        if (this.offlineNoticeTimer || this.shouldShowOfflineNotice) {
            return;
        }

        this.offlineNoticeTimer = setTimeout(() => {
            runInAction(() => {
                this.offlineNoticeTimer = undefined;
                if (this.isServerUnavailable) {
                    this.shouldShowOfflineNotice = true;
                }
            });
        }, OFFLINE_NOTICE_DELAY_MS);
    }

    reportSuccess() {
        if (this.offlineNoticeTimer) {
            clearTimeout(this.offlineNoticeTimer);
            this.offlineNoticeTimer = undefined;
        }

        this.isServerUnavailable = false;
        this.shouldShowOfflineNotice = false;
        this.lastUnavailableAt = undefined;
        this.lastErrorMessage = undefined;
    }
}

export const serverAvailabilityStore = new ServerAvailabilityStore();

export function reportServerConnectionFailure(error: unknown) {
    serverAvailabilityStore.reportFailure(error);
}

export function reportServerConnectionRestored() {
    serverAvailabilityStore.reportSuccess();
}
